import Cookies from 'js-cookie';

// Lightweight adapter for cookie/storage with consent checks

export const oauthServiceConsentAdapter = {
  setCookie(name: string, value: string, options?: Cookies.CookieAttributes) {
    // OAuth flow is essential for authentication; treat as necessary
    Cookies.set(name, value, options);
  },
  getCookie(name: string): string | undefined {
    return Cookies.get(name);
  },
  removeCookie(name: string) {
    Cookies.remove(name);
  },
};

export const storageWithConsent = {
  setItem(key: string, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch {}
  },
};
